import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { isMockMode } from './config/env';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root was not found in index.html');
}

/**
 * The mock worker must be running before the first request goes out, so mounting waits on
 * it. `isMockMode` folds to a literal false in a production build, which lets Rollup drop
 * this dynamic import and keep MSW out of the shipped bundle entirely.
 */
async function bootstrap(): Promise<void> {
  if (isMockMode) {
    const { startMockApi } = await import('./mocks/browser');
    await startMockApi();
  } else if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(
      registrations
        .filter((registration) =>
          (registration.active?.scriptURL ?? registration.installing?.scriptURL ?? '').includes(
            'mockServiceWorker'
          )
        )
        .map((registration) => registration.unregister())
    );
  }

  createRoot(rootElement as HTMLElement).render(<App />);
}

void bootstrap();
